import {
    CLEAR_PAPER_REPORT,
    FETCH_PAPER_REPORT,
    LIST_PAPER_REPORT
} from "./types";

const init = {
    isLoading: false,
    list: [],
    filter: {},
    page: 1,
    totals: 0,
    size: 50
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_PAPER_REPORT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_PAPER_REPORT:
            return {
                ...state,
                isLoading: false,
                list: payload.data,
                ...payload.paging
            };
        case CLEAR_PAPER_REPORT:
            return {
                isLoading: false,
                list: []
            };
        default:
            return state;
    }
}